import styled from "@emotion/styled"
import ContainerWrapper from "pazChargeComponents/general/ContainerWrapper";
import React from "react"
import Wallet from "components/PazClub/Wallet";



const StyledWrapper = styled.div`
  background: linear-gradient(
    180deg,
    rgba(21, 62, 105, 0.06) 0%,
    rgba(51, 67, 84, 0) 100%
  );
`

function WalletWrapperChargeBlock({ data }: { data: any }) {

    return (
        <StyledWrapper>
            <ContainerWrapper>
                <Wallet defaultPadding={false} data={data} defaultBackground={false}></Wallet>
            </ContainerWrapper>
        </StyledWrapper>

    )
}

export default WalletWrapperChargeBlock
